import React from 'react'
import { Box } from '@mui/material'
import { Receipt } from '@mui/icons-material'

const Transactions: React.FC = () => {
  return (
    <Box sx={{ maxWidth: '1280px', mx: 'auto' }}>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Box component="h1" sx={{ fontSize: '1.875rem', fontWeight: 'bold', color: 'text.primary', mb: 1 }}>
          Transactions
        </Box>
        <Box component="p" sx={{ color: 'text.secondary' }}>
          Monitor and manage all platform transactions
        </Box>
      </Box>

      {/* Coming Soon Card */}
      <Box sx={{ 
        bgcolor: 'background.paper', 
        borderRadius: 2, 
        boxShadow: 1, 
        p: 6, 
        textAlign: 'center' 
      }}>
        <Box sx={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          width: 96, 
          height: 96, 
          bgcolor: 'primary.lighter',
          borderRadius: '50%', 
          mb: 3 
        }}>
          <Receipt sx={{ fontSize: 48, color: 'primary.main' }} />
        </Box>
        <Box component="h2" sx={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'text.primary', mb: 2 }}>
          Transactions Feature Coming Soon
        </Box>
        <Box component="p" sx={{ color: 'text.secondary', maxWidth: 800, mx: 'auto', mb: 3 }}>
          We're working on bringing you a comprehensive transaction management system to help you monitor 
          payments, track financial activities, manage refunds, and generate detailed transaction reports 
          all in one place.
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center', fontSize: '0.875rem', color: 'text.secondary' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>Payment Tracking</span>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>Transaction History</span>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>Refund Management</span>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span" sx={{ color: 'success.main' }}>✓</Box>
            <span>Financial Reports</span>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Transactions
